module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[66]309.75bfc8f.woff2";